import React from "react";
import {Redirect} from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "src/hooks/useAuth";
import {URL_TEMPLATES as URL} from "src/urlTemplates";

const GuestGuard = ({children}) => {
    const {isAuthenticated} = useAuth();

    if (isAuthenticated) {
        return <Redirect to={URL.APP}/>;
    }

    return <>{children}</>;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
